// extracted by mini-css-extract-plugin
export default {"popover":"popover_popover__cF-5C","show":"popover_show__IfuUw","fullWidth":"popover_fullWidth__y0Jz4"};